<button (click)="update()" [disabled]="!btnUpdate" class="mr-1" color="accent" mat-icon-button text="Modificar">
  <fa-icon icon="edit"></fa-icon>
</button>

<button (click)="remove()" [disabled]="!btnDelete" color="warn" mat-icon-button text="Eliminar">
  <fa-icon icon="trash"></fa-icon>
</button>
